import type { ValidationRule } from '@insurancemenu/imenu-components-lib/dist/utils/forms';

/** Blocklist of ineligible SIC codes/prefixes */
const ALLIED_ELIGIBLE_SIC_CODE_REGEX = /^(?!076[1-9]|077\d|078[0-3]|86\d{2})\d{4}$/;

export const alliedSICValidation: ValidationRule = {
  check: (value: string): boolean => ALLIED_ELIGIBLE_SIC_CODE_REGEX.test(value),
  msg: 'Ineligible SIC Code',
};
